const API_BASE = '/api/prisme-files';

export interface PrismeUploadedFile {
  id: string;
  originalName: string;
  storedName: string;
  mimeType?: string;
  sizeBytes: number;
  category: string;
  source: string;
  createdAt: string;
  uploadedBy?: string;
  downloadUrl: string;
}

export interface PrismeFileProject {
  id: string;
  slug: string;
  title: string;
  status: string;
  decision_date?: string;
  description?: string;
}

export interface PrismeProjectFilesResponse {
  project: PrismeFileProject;
  files: PrismeUploadedFile[];
}

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || `Erreur HTTP ${response.status}`);
  }
  return payload as T;
}

export async function listProjectFiles(slug: string): Promise<PrismeProjectFilesResponse> {
  const response = await fetch(`${API_BASE}/projects/${encodeURIComponent(slug)}/files`, {
    credentials: 'include',
  });
  return parseJsonResponse<PrismeProjectFilesResponse>(response);
}

export async function uploadProjectFiles(slug: string, files: FileList | File[]): Promise<{ uploaded: PrismeUploadedFile[] }> {
  const body = new FormData();
  Array.from(files).forEach((file) => body.append('files', file));
  body.append('category', 'source');

  const response = await fetch(`${API_BASE}/projects/${encodeURIComponent(slug)}/files`, {
    method: 'POST',
    credentials: 'include',
    body,
  });
  return parseJsonResponse<{ uploaded: PrismeUploadedFile[] }>(response);
}

export function getFileDownloadUrl(fileId: string): string {
  return `${API_BASE}/files/${encodeURIComponent(fileId)}/download`;
}
